import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-secondary-100 text-4xl text-secondary-700">
        <i className="ri-film-line"></i>
      </span>
      <p className="mt-6 font-label text-5xl font-black text-accent-600">404</p>
      <h1 className="mt-3 text-2xl font-black text-foreground-950">页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面不存在或已被移除。不妨回到首页，继续探索精彩的影视内容。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
        >
          <i className="ri-home-5-line"></i>
          返回首页
        </Link>
        <Link
          to="/movies"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-600"
        >
          <i className="ri-movie-2-line"></i>
          浏览电影
        </Link>
      </div>
    </div>
  );
}